<template>
  <Verbrauch type="kaltwasser"/>
</template>

<script>
import Verbrauch from '@/components/Verbrauch';

export default {
  components: {
    Verbrauch,
  },
};
</script>
